import {Component, Input} from '@angular/core';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'slm-no-image',
    templateUrl: './no-image.component.html',
    styleUrls: ['no-image.component.scss'],
    imports: [SvgIconComponent, TranslatePipe]
})
export class NoImageComponent {
  @Input() placeholderTitle: string;
  @Input() placeholderDescription: string;
}
